function f1(ctx, node) {
    var i;
    var n, r, o = node.rect.height;
    var s = node.rect.width;
    n = s < o / 2 ? node.rect.width / 2 : o / 4;
    r = 1 * n / 2;
    const a = node.data[0].value, c = node.data[1].value;
    var l = node.rect.x + 3 * r, h = node.rect.y;
    ctx.save(),
    ctx.fillStyle = null != (i = node.fontColor) ? i : "#000";
    var u = s > o / 2 ? o / 20 : s / 10;
    ctx.font = u + "px Arial";
    for (var d = a; d <= c; d++) {
        const i = Zs(node, d, n, r);
        ctx.beginPath();
        ctx.moveTo(l, i + h);
        d % 10 == 0 ? (ctx.lineWidth = 2,
        ctx.lineTo(l + 2 * r / 3, i + h),
        ctx.fillText(d, l + 15 + u, i + 6 + h),
        ctx.stroke()) : (ctx.lineWidth = 1,
        d % 5 == 0 ? ctx.lineTo(l + r / 2, i + h) : ctx.lineTo(l + r / 3, i + h));
        ctx.stroke();
    }
    ctx.restore();
}

function f2(ctx, node, i, n) {
    ctx.beginPath(),
    ctx.arc(node.rect.x + i, node.rect.y + n, n, 0, Math.PI, !0);
    const r = Math.acos(1 * n / i);
    ctx.arc(node.rect.x + i, node.rect.y + node.rect.height - i, i, r + Math.PI, -r, !0),
    ctx.lineTo(node.rect.x + i + n, node.rect.y + n),
    ctx.stroke(),
    ctx.closePath()
}

function f3(ctx, node, i, n) {
    var r, o = node.value;
    r = o < node.data[0].value ? Zs(node, node.data[0].value, i, n) : o > node.data[1].value ? Zs(node, node.data[1].value, i, n) : Zs(node, o, i, n);
    ctx.beginPath(),
    ctx.moveTo(node.rect.x + 3 * n, node.rect.y + r),
    ctx.rect(node.rect.x + n + .5, node.rect.y + r, 2 * n - 1, node.rect.height - i - r),
    ctx.closePath(),
    ctx.fill();
    const s = Math.acos(1 * n / i);
    ctx.beginPath(),
    ctx.arc(node.rect.x + i, node.rect.y + node.rect.height - i, i - .5, s + Math.PI, -s, !0),
    ctx.fill(),
    ctx.closePath()
}

function Zs(t, e, i, n) {
    const r = (t.rect.height - 2 * i - n) / (t.data[1].value - t.data[0].value);
    return t.rect.height - 2 * i + r * t.data[0].value - r * e
}

export function thermometer(ctx, node) {
    var i, n;
    i = node.rect.width < node.rect.height / 2 ? node.rect.width / 2 : node.rect.height / 4;
    n = 1 * i / 2;
    null == node.data[1].value && (node.data[1].value = 20);
    null == node.data[0].value && (node.data[0].value = -20);
    node.fillStyle || (node.fillStyle = "#F40");
    f1(ctx, node);
    f2(ctx, node, i, n);
    f3(ctx, node, i, n);
    ctx.closePath();
}

/*export function register_thermometer() {
  (window).Le5leTopology.registerNode('thermometer', thermometer);
}*/